import {
  configureStore,
  // applyMiddleware
} from '@reduxjs/toolkit';

import CustomizerReducer from './customizer/CustomizerSlice';
import userReducer from '../slices/authSlice/userSilce';
import userMgtSlice from '../slices/usersSlice/userMgtSlice';

export const store = configureStore(
  {
    reducer: {
      customizer: CustomizerReducer,
      // user
      user: userReducer,
      userMgt: userMgtSlice
    },
  },
  // applyMiddleware(CryptoMiddleWare)
);

export default store;
